import { PrimeReactProvider } from "primereact/api";
import { ConfirmPopup } from "primereact/confirmpopup";
import React, { Suspense, useEffect, useState } from 'react';
import RouteFallback from "./Components/Template/RouteFallback/RouteFallback";
import { createPortal } from 'react-dom';
import { applyCachedBrowserBranding, reloadBrowserBrandingForSession } from "./Template/custom-styling/applyBrowserBranding";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import secureLocalStorage from 'react-secure-storage';
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import './Scss/toast.scss';
import { MenuProvider } from "./Components/Template/MenuBar/MenuContext";
import { SideBarProvider } from './Components/Template/Sidebar/SidebarContext';
import { MARKETPLACE_OAUTH_CALLBACK_PATH } from './Pages/Marketplace/marketplaceOAuthBootstrap';
import {
	MARKETPLACE_CONNECTION_ROUTE,
	MARKETPLACE_ROUTE,
	MARKETPLACE_SETUP_ROUTE,
} from './Pages/Marketplace/marketplaceConstants';
import SignIn from "./Pages/SignIn/signIn";
import { UserService } from './Services/userService';
import applyCustomerStyling from './Template/custom-styling/custom-styling';
import NavBar from "./Template/Navbar/Navbar";
import NewSideBar from './Template/SideBar/newSideBar';
import MyErrorBoundary from './Util/ErrorBoundary/ErrorBoundary';
import Protected from "./Util/Protected";
import KnowledgeBase from "./Pages/KnowledgeBase/KnowledgeBase";
import KnowledgeArticleDetail from "./Pages/KnowledgeBase/KnowledgeArticleDetail";
import KnowledgeArticleEditor from "./Pages/KnowledgeBase/KnowledgeArticleEditor";
import { KNOWLEDGE_ARTICLE_CREATE_PATH, KNOWLEDGE_BASE_LIST_PATH } from "./Pages/KnowledgeBase/knowledgeBaseConstants";
import { OBJECTIVE_LIST_PATH } from "./Pages/Objective/objectiveRoutes";
import { PROJECT_LIST_PATH } from "./Pages/Project/projectConstants";
import { isStandaloneRoute } from "./Util/standaloneRoutes";
import {PageHeaderProvider} from "./Components/Template/PageTitle/PageContext";
import {SavedFilterScopeProvider} from "./Components/Template/PageTitle/SavedFilterScopeContext";
import PageTitle from "./Template/PageTitle/PageTitle";

import {
	Metric,
	AskAI,
	DashboardView,
	DashboardViewer,
	HomeScreen,
	Component,
	CustomerWizard,
	DashboardCategory,
	Dataservice,
	AuthenticationType,
	Permission,
	AccessCenter,
	RoleEditor,
	UserEditor,
	Marketplace,
	MarketplaceDatasourceDetailPage,
	MarketplaceDatasourceSetupPage,
	Notifications,
	ModifyCommunicationSettingsPage,
	ExternalNotificationPreferencesPage,
	SettingsHub,
	SettingsProfilePage,
	SettingsCommunicationPage,
	SettingsSecurityPage,
	SettingsAiConnectionPage,
	SettingsSavedFiltersPage,
	SettingsVersionPage,
	SettingsConfidentialSharePage,
	SettingsDynamicTranslationsPage,
	SettingsPlatformPage,
	ConfidentialShareViewPage,
	MetricView,
	MessageEvent,
	Recipient,
	Cache,
	DashlyEmail,
	GenericSelectItem,
	ExternalUser,
	Alerts,
	AlertDetail,
	Processflows,
	ProcessflowDetail,
	Objectives,
	ObjectiveDetail,
	Projects,
	ProjectDetail,
	DataHero,
	DashboardBuilder,
	MarketplaceOAuthCallbackPage,
	ProjectCatalogProvider,
	ErrorHandling,
} from "./routes/lazyRoutes";

const App = () => {
    const userAuth = secureLocalStorage.getItem('user') as string;
    const [reloadProfile, setReloadProfile] = useState(false);
    const [reloadLogo, setReloadLogo] = useState(false);
    const location = useLocation();
    const [user, setUser] = useState(null);
    const [userService] = React.useState(new UserService());
    const [sideBarToggle, setSideBarTogle] = useState(false);
    const [systemValueToggle, setSystemValueToggle] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        if (userAuth) {
            void reloadBrowserBrandingForSession();
            return;
        }
        applyCachedBrowserBranding();
    }, [userAuth]);

    useEffect(() => {
        applyCachedBrowserBranding();
    }, [location.pathname]);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 1201) {
                setIsMobile(true);
            } else {
                setIsMobile(false)
            }
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        if (userAuth) {
            fetchStyling();
        }
    }, []);

    const fetchStyling = async () => {
        try {
            const result = await new UserService().getCustomerStyling();
            if (result.data && Array.isArray(result.data) && result.data.length > 0) {
                secureLocalStorage.setItem("customerStyling", JSON.stringify(result.data[0]));
            }
            applyCustomerStyling();

        } catch (error) {
            console.error("Error fetching customer styling", error);
        }
    };

    const toggleSideBar = () => {
        setSideBarTogle(!sideBarToggle)
    }

    const toggleSystemValue = () => {
        setSystemValueToggle(!systemValueToggle)
    }

    useEffect(() => {
        if (!sideBarToggle) {
            setSystemValueToggle(false);
        }
    }, [sideBarToggle]);

    useEffect(() => {
        if (userAuth) {
            setUser(JSON.parse(userAuth));
        } else {
            setUser(null);
        }
    }, [location, reloadProfile]);

    const standalone = isStandaloneRoute(location.pathname);

    return (
        <PrimeReactProvider>
            <SideBarProvider>
                <MenuProvider>
                    <PageHeaderProvider>
                    <SavedFilterScopeProvider>
	                    {createPortal(<ToastContainer />, document.body)}

	                    <div className='app_main'>

	                        {user && !standalone && (<div className='im-menubar'>
	                            <NavBar toggleSideBar={toggleSideBar} sideBar={sideBarToggle} openDialog={setSideBarTogle} reloadProfile={reloadProfile} setReloadProfile={setReloadProfile} />
	                        </div>)}
	                        {user && !standalone && (<div className='im-sidebar-container'>
	                            <NewSideBar sideBar={sideBarToggle} closeDialog={setSideBarTogle} toggleSystemValue={toggleSystemValue} systemValueToggle={systemValueToggle} />
	                            {/* <SideBar toggleSideBar={toggleSideBar} sideBar={sideBarToggle} closeDialog={setSideBarTogle} toggleSystemValue={toggleSystemValue} systemValueToggle={systemValueToggle}  reloadLogo={reloadLogo} setReloadLogo={setReloadLogo}  /> */}
	                        </div>)}

	                        {/*{!isMobile && (*/}
	                        {/*    <img src={corner} className="corner" />*/}
	                        {/*)}*/}

	                        <div className={standalone ? '' : `app-content-wrapper ${isMobile && sideBarToggle ? 'mobile-sidebar-open' : 'mobile-sidebar-closed'}`}>
	                            <div className={standalone ? '' : 'im-content'}>
		                            {!standalone && <PageTitle />}

	                                <ConfirmPopup />
	                                <MyErrorBoundary>
	                                    {/* Suspense inside the boundary: chunk-load errors still reach it,
	                                        and its key={pathname} resets it per route. */}
	                                    <Suspense fallback={<RouteFallback />}>
	                                    <Routes >
	                                        <Route path={MARKETPLACE_OAUTH_CALLBACK_PATH} element={<MarketplaceOAuthCallbackPage />} />

	                                        <Route element={<Protected />}>
	                                            <Route path='/' element={<HomeScreen />} />
	                                        </Route>

	                                        {/* TODO: Remove the before setting to LIVE. */}
	                                        {/*<Route element={<Protected />}>*/}
	                                        {/*    <Route path='/openai' element={<OpenAiScreen />} />*/}
	                                        {/*</Route>*/}

	                                        <Route element={<Protected />}>
	                                            <Route path='/system/metric' element={<Metric />} />
	                                        </Route>

	                                        <Route element={<Protected />}>
	                                            <Route path='/system/metric-view' element={<MetricView />} />
	                                        </Route>

		                                    <Route element={<Protected />}>
			                                    <Route path='/system/cache' element={<Cache />} />
		                                    </Route>

		                                    <Route element={<Protected />}>
			                                    <Route path='/system/dashly-email' element={<DashlyEmail />} />
		                                    </Route>

		                                    <Route element={<Protected />}>
			                                    <Route path='/system/generic-select-item' element={<GenericSelectItem />} />
		                                    </Route>

		                                    <Route element={<Protected />}>
			                                    <Route path='/system/external-user' element={<ExternalUser />} />
		                                    </Route>

		                                    <Route element={<Protected />}>
			                                    <Route path='/system/dataservice' element={<Dataservice />} />
		                                    </Route>

		                                    <Route element={<Protected />}>
			                                    <Route path='/system/authentication-type' element={<AuthenticationType />} />
		                                    </Route>

		                                    <Route element={<Protected />}>
			                                    <Route path='/system/authentication-type-field' element={<AuthenticationType />} />
		                                    </Route>

	                                        <Route element={<Protected />}>
	                                            <Route path='/management/access' element={<AccessCenter />} />
	                                            <Route path='/management/access/role/:roleUuid' element={<RoleEditor />} />
	                                            <Route path='/management/access/user/:userUuid' element={<UserEditor />} />
	                                        </Route>
	                                        <Route element={<Protected />}>
	                                            <Route path='/management/user' element={<Navigate to="/management/access?tab=users" replace />} />
	                                        </Route>
	                                        <Route element={<Protected />}>
	                                            <Route path='/management/role' element={<Navigate to="/management/access" replace />} />
	                                        </Route>
	                                        <Route element={<Protected />}>
	                                            <Route path='/management/permission' element={<Permission />} />
	                                        </Route>
	                                        <Route element={<Protected />}>
	                                            <Route path='/management/customer' element={<Navigate to="/management/access" replace />} />
	                                        </Route>
	                                        <Route element={<Protected />}>
	                                            <Route path='/management/customer/wizard' element={<CustomerWizard />} />
	                                        </Route>
	                                        <Route element={<Protected />}>
	                                            <Route path='/management/messageEvent' element={<MessageEvent />} />
	                                        </Route>

	                                        <Route element={<Protected />}>
	                                            <Route path='/management/recipient' element={<Recipient />} />
	                                        </Route>

	                                        {/* <Route element={<Protected />}>
	                                            <Route path='/management/dashboard' element={<Dashboard />} />
	                                        </Route> */}
	                                        <Route element={<Protected />}>
	                                            <Route path='/ask-ai' element={<AskAI />} />
	                                        </Route>
	                                        <Route element={<Protected />}>
	                                            <Route path='/management/dashboard/:dashboardUuid' element={<DashboardBuilder />} />
	                                        </Route>
		                                    <Route element={<Protected />}>
			                                    <Route path='/management/dashboard/:dashboardUuid/sub' element={<DashboardBuilder sub={true} />} />
		                                    </Route>
	                                        <Route element={<Protected />}>
	                                            <Route path='/management/dashboard-category' element={<DashboardCategory />} />
	                                        </Route>

	                                        <Route element={<Protected />}>
	                                            <Route path='/management/component' element={<Component />} />
	                                        </Route>

	                                        <Route element={<Protected />}>
	                                            <Route path='/notifications' element={<Notifications />} />
	                                        </Route>

		                                    <Route element={<Protected />}>
			                                    <Route path='/data-hero' element={<DataHero />} />
		                                    </Route>

	                                        <Route element={<Protected />}>
	                                            <Route element={<ProjectCatalogProvider />}>
	                                                <Route path={PROJECT_LIST_PATH} element={<Projects />} />
	                                                <Route path={`${PROJECT_LIST_PATH}/:uuid`} element={<ProjectDetail />} />
	                                            </Route>
	                                        </Route>
	                                        <Route element={<Protected />}>
	                                            <Route path='/alerts' element={<Alerts />} />
	                                        </Route>
	                                        <Route element={<Protected />}>
	                                            <Route path='/alerts/:uuid' element={<AlertDetail />} />
	                                        </Route>
	                                        <Route element={<Protected />}>
	                                            <Route path='/processflows' element={<Processflows />} />
	                                        </Route>
	                                        <Route element={<Protected />}>
	                                            <Route path='/processflows/:uuid' element={<ProcessflowDetail />} />
	                                        </Route>
	                                        <Route element={<Protected />}>
	                                            <Route path={OBJECTIVE_LIST_PATH} element={<Objectives />} />
	                                        </Route>
	                                        <Route element={<Protected />}>
	                                            <Route path={`${OBJECTIVE_LIST_PATH}/:uuid`} element={<ObjectiveDetail />} />
	                                        </Route>
	                                        <Route element={<Protected />}>
	                                            {/* Knowledge base is browsable without a GCP project; create is gated
	                                                in-page (KnowledgeBaseGcpCreateDisabledBanner). */}
	                                            <Route path={KNOWLEDGE_BASE_LIST_PATH} element={<KnowledgeBase />} />
	                                            <Route path={KNOWLEDGE_ARTICLE_CREATE_PATH} element={<KnowledgeArticleEditor />} />
	                                            <Route path={`${KNOWLEDGE_BASE_LIST_PATH}/:uuid/edit`} element={<KnowledgeArticleEditor />} />
	                                            <Route path={`${KNOWLEDGE_BASE_LIST_PATH}/:uuid`} element={<KnowledgeArticleDetail />} />
	                                        </Route>
	                                        {/* settings */}
	                                        <Route element={<Protected />}>
	                                            <Route path="/settings" element={<SettingsHub reloadProfile={reloadProfile} setReloadProfile={setReloadProfile} />} />
	                                            <Route path="/settings/profile" element={<SettingsProfilePage reloadProfile={reloadProfile} setReloadProfile={setReloadProfile} />} />
	                                            <Route path="/settings/communication" element={<SettingsCommunicationPage />} />
	                                        <Route path="/settings/security" element={<SettingsSecurityPage />} />
	                                        <Route path="/settings/ai-connection" element={<SettingsAiConnectionPage />} />
	                                        <Route path="/settings/saved-filters" element={<SettingsSavedFiltersPage />} />
	                                            <Route path="/settings/version" element={<SettingsVersionPage />} />
	                                            <Route path="/settings/confidential-share" element={<SettingsConfidentialSharePage />} />
	                                            <Route path="/settings/translations" element={<SettingsDynamicTranslationsPage />} />
	                                            <Route path="/settings/platform" element={<SettingsPlatformPage />} />
	                                            <Route path="/profile/settings" element={<Navigate to="/settings" replace />} />
	                                        </Route>

	                                        <Route path='/sign-in' element={<SignIn />} />
	                                        <Route path='/reset-password/:uuid' element={<SignIn />} />
	                                        <Route path='/Authentication' element={<SignIn />} />
	                                        <Route path='/Authentication-App' element={<SignIn />} />
	                                        <Route element={<Protected />}>
	                                            <Route path='/error-handling' element={<ErrorHandling />} />
	                                        </Route>

	                                        <Route path='/modify-communication-settings' element={<ModifyCommunicationSettingsPage />} />
	                                        <Route path='/external-notification-preferences' element={<ExternalNotificationPreferencesPage />} />
	                                        <Route path='/share/:accessToken' element={<ConfidentialShareViewPage />} />


	                                        {/* Dashly */}

	                                        <Route element={<Protected />}>
	                                            <Route path='/dashboard/:dashboardUuid' element={<DashboardView />} />
	                                        </Route>

		                                    <Route element={<Protected />}>
			                                    <Route path='/dashboard/:dashboardUuid/sub' element={<DashboardView sub={true} />} />
		                                    </Route>

	                                        <Route element={<Protected />}>
	                                            <Route path='/dashboards' element={<DashboardViewer />} />
	                                        </Route>

	                                        <Route element={<Protected />}>
	                                            <Route path={MARKETPLACE_ROUTE} element={<Marketplace />} />
	                                        </Route>
	                                        <Route element={<Protected />}>
	                                            <Route path={`${MARKETPLACE_SETUP_ROUTE}/:datasourceUuid`} element={<MarketplaceDatasourceSetupPage />} />
	                                        </Route>
	                                        <Route element={<Protected />}>
	                                            <Route path={`${MARKETPLACE_CONNECTION_ROUTE}/:datasourceUuid`} element={<MarketplaceDatasourceDetailPage />} />
	                                        </Route>
	                                    </Routes>
	                                    </Suspense>
	                                </MyErrorBoundary>
	                            </div>
	                        </div>
	                    </div>
                    </SavedFilterScopeProvider>
                    </PageHeaderProvider>
                </MenuProvider>
            </SideBarProvider>
        </PrimeReactProvider>
    );
}

export default App;
